import { WorkspaceRoleV2 } from 'modules/CreateWorkspaceModal/types';
import { DefaultRoleTypesEnum } from 'modules/Workspaces/hooks/useCreateWorkspaceRole/utils';

/**
 * Roles an actor may assign in workspace settings or invite flows (MIP-035):
 * exclude Owner; workspace PL must be strictly less than the actor's workspace PL
 * (actors cannot assign their own role — they could not unassign it afterward).
 * Sorted by workspace PL descending (highest assignable role first).
 */
const getAssignableWorkspaceRoles = (workspaceRoles: WorkspaceRoleV2[], actorWorkspacePowerLevel: number) =>
  workspaceRoles
    .filter(
      ({ defaultRoleType, powerLevels }) =>
        defaultRoleType !== DefaultRoleTypesEnum.OWNER && powerLevels.workspace < actorWorkspacePowerLevel
    )
    .sort((a, b) => b.powerLevels.workspace - a.powerLevels.workspace);

/** Lowest workspace PL among assignable roles (typical default for invite / assignment). */
export const getDefaultAssignableWorkspaceRole = (assignableRoles: WorkspaceRoleV2[]) => assignableRoles.at(-1) ?? null;

export default getAssignableWorkspaceRoles;
